import { CustomIconProps } from './art';

export const CovidIcon = ({ fill }: CustomIconProps): JSX.Element => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.725 2.22a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-.47-.47L18.56 8.5l2.47 2.47a.75.75 0 1 1-1.06 1.06l-1.47-1.47-6.842 6.841a3.75 3.75 0 0 1-2.65 1.098H6.56l-3.28 3.28a.75.75 0 0 1-1.06-1.06l3.28-3.28v-2.447a3.75 3.75 0 0 1 1.097-2.652L6.94 12l1.53 1.53a.75.75 0 0 0 1.061-1.06l-1.53-1.53.94-.94 1.53 1.53a.75.75 0 1 0 1.06-1.06L10 8.94l.94-.94 1.53 1.53a.749.749 0 1 0 1.06-1.06L12 6.94l1.44-1.44-1.47-1.47a.75.75 0 0 1 1.06-1.06l2.47 2.47 1.693-1.69-.47-.47a.75.75 0 0 1 0-1.06h.001Zm2.47 3.53-.94-.94L16.56 6.5l.94.94 1.693-1.69Z"
      fill={fill ? fill : 'url(#a)'}
    />
    <defs>
      <linearGradient
        id="a"
        x1="2.453"
        y1="9.853"
        x2="22.832"
        y2="9.853"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#259BE9" />
        <stop offset="1" stopColor="#AFDAF7" />
      </linearGradient>
    </defs>
  </svg>
);
